import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1bb18af2")

_pushScopeId("data-v-1bb18af2")
const _hoisted_1 = { class: "card card-p add-products" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-7" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-6" }
const _hoisted_6 = { class: "col-md-6" }
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = { class: "col-md-12" }
const _hoisted_9 = { class: "d-flex align-items-center fs-6 fw-bold mb-2" }
const _hoisted_10 = {
  key: 0,
  class: "errors"
}
const _hoisted_11 = { class: "row fv-row" }
const _hoisted_12 = { class: "col-md-12" }
const _hoisted_13 = { class: "col-md-12 d-flex flex-column" }
const _hoisted_14 = { class: "d-flex align-items-center fs-6 fw-bold mb-1" }
const _hoisted_15 = { class: "col-md-12" }
const _hoisted_16 = { class: "d-flex align-items-center fs-6 fw-bold mt-10 mb-2" }
const _hoisted_17 = { class: "col-md-1 text-center" }
const _hoisted_18 = { class: "col-md-4" }
const _hoisted_19 = { class: "mb-7" }
const _hoisted_20 = { class: "indicator-label" }
const _hoisted_21 = { class: "section-border pb-2 lang-switch d-flex flex-wrap justify-content-between align-items-center" }
const _hoisted_22 = { class: "fs-5 fw-bolder" }
const _hoisted_23 = { class: "lang-switch-inner" }
const _hoisted_24 = { class: "section-border pt-7 pb-4" }
const _hoisted_25 = { class: "d-flex align-items-center fs-5 fw-bolder mb-3" }
const _hoisted_26 = { class: "section-border select-line-height pt-7 pb-2" }
const _hoisted_27 = { class: "d-flex align-items-center fs-5 fw-bolder mb-2" }
const _hoisted_28 = { class: "section-border select-line-height pt-7 pb-2" }
const _hoisted_29 = { class: "d-flex align-items-center fs-5 fw-bolder mb-2" }
const _hoisted_30 = { class: "section-border handler pt-7 pb-4" }
const _hoisted_31 = { class: "d-flex align-items-center mb-2 fs-5 fw-bolder" }
const _hoisted_32 = {
  key: 0,
  class: "col-md-12 mt-5"
}
const _hoisted_33 = { class: "row" }
const _hoisted_34 = { class: "col-md-6" }
const _hoisted_35 = { class: "col-md-6" }
const _hoisted_36 = { class: "section-border py-7" }
const _hoisted_37 = { class: "d-flex align-items-center mb-2 fs-5 fw-bolder" }
const _hoisted_38 = { style: {"max-width":"150px"} }
const _hoisted_39 = {
  key: 0,
  class: "errors"
}
const _hoisted_40 = { class: "section-border row pt-7" }
const _hoisted_41 = { class: "col-md-6" }
const _hoisted_42 = { class: "d-flex align-items-center mb-2 fs-5 fw-bolder" }
const _hoisted_43 = { class: "col-md-6" }
const _hoisted_44 = { class: "d-flex align-items-center mb-2 fs-5 fw-bolder" }
const _hoisted_45 = { class: "section-border row pt-7 border-0" }
const _hoisted_46 = { class: "col-md-12" }
const _hoisted_47 = /*#__PURE__*/_createVNode("div", { style: {"clear":"both"} }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_Input = _resolveComponent("Input")!
  const _component_QuillEditor = _resolveComponent("QuillEditor")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_Select = _resolveComponent("Select")!
  const _component_ProductToMedia = _resolveComponent("ProductToMedia")!
  const _component_ProductToAttributes = _resolveComponent("ProductToAttributes")!
  const _component_ProductToPrice = _resolveComponent("ProductToPrice")!
  const _component_ProductToPriceGroups = _resolveComponent("ProductToPriceGroups")!
  const _component_ProductToCustomerPrices = _resolveComponent("ProductToCustomerPrices")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_ProductToDimension = _resolveComponent("ProductToDimension")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_Radio = _resolveComponent("Radio")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_InnerLoader, { loading: _ctx.loader }, null, 8, ["loading"]),
    _createVNode(_component_el_form, {
      model: _ctx.product,
      ref: "addProductForm"
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_el_tabs, {
              "tab-position": 'top',
              modelValue: _ctx.tabs,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.tabs = $event)),
              onTabClick: _ctx.loadTabData
            }, {
              default: _withId(() => [
                _createVNode(_component_el_tab_pane, {
                  label: `${_ctx.$t('message.BASIC')}`
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_4, [
                      _createVNode("div", _hoisted_5, [
                        _createVNode(_component_Input, {
                          type: "text",
                          name: "name",
                          label: `${_ctx.$t('message.NAME')} (${_ctx.locale})`,
                          required: true,
                          placeholder: 'message.ENTER message.NAME',
                          requiredMsg: `${_ctx.$t('message.NAME')} ${_ctx.$t('message.IS_REQUIRED')}`,
                          "onUpdate:name": _cache[1] || (_cache[1] = ($event: any) => (_ctx.product.name = $event)),
                          target: "name",
                          onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateValue(_ctx.product.name, 'name'))),
                          value: _ctx.product.name
                        }, null, 8, ["label", "placeholder", "requiredMsg", "name", "value"])
                      ]),
                      _createVNode("div", _hoisted_6, [
                        _createVNode(_component_Input, {
                          type: "text",
                          name: "product_number",
                          label: `${_ctx.$t('message.PRODUCT_NUMBER')}`,
                          required: true,
                          placeholder: 'message.ENTER message.PRODUCT_NUMBER',
                          requiredMsg: `${_ctx.$t('message.PRODUCT_NUMBER')} ${_ctx.$t('message.IS_REQUIRED')}`,
                          product_number: _ctx.product.product_number,
                          "onUpdate:product_number": _cache[3] || (_cache[3] = ($event: any) => (_ctx.product.product_number = $event)),
                          target: "product_number",
                          value: _ctx.product.product_number
                        }, null, 8, ["label", "placeholder", "requiredMsg", "product_number", "value"])
                      ]),
                      _createVNode("div", _hoisted_7, [
                        _createVNode(_component_Input, {
                          type: "text",
                          name: "label",
                          label: `${_ctx.$t('message.LABEL')} (${_ctx.locale})`,
                          placeholder: 'message.ENTER message.LABEL',
                          requiredMsg: `${_ctx.$t('message.LABEL')} ${_ctx.$t('message.IS_REQUIRED')}`,
                          "onUpdate:label": _cache[4] || (_cache[4] = ($event: any) => (_ctx.product.label = $event)),
                          target: "label",
                          onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateValue(_ctx.product.label, 'label'))),
                          value: _ctx.product.label
                        }, null, 8, ["label", "placeholder", "requiredMsg", "value"])
                      ]),
                      _createVNode("div", _hoisted_8, [
                        _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('message.DESCRIPTION')) + " (" + _toDisplayString(_ctx.locale) + ") ", 1),
                        _createVNode(_component_QuillEditor, {
                          onTextChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onEditorChange($event, 'description'))),
                          contentType: "html",
                          ref: "editorForm",
                          theme: "snow",
                          content: _ctx.product.description,
                          "onUpdate:content": _cache[7] || (_cache[7] = ($event: any) => (_ctx.product.description = $event)),
                          toolbar: "full"
                        }, null, 8, ["content"]),
                        ((_ctx.product.description == '' && _ctx.validate == true) || _ctx.product.description === '<p><br></p>')
                          ? (_openBlock(), _createBlock("div", _hoisted_10, _toDisplayString(_ctx.$t('message.DESCRIPTION')) + " " + _toDisplayString(_ctx.$t('message.IS_REQUIRED')), 1))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_tab_pane, {
                  label: `${_ctx.$t('message.META')}`,
                  name: "meta"
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_11, [
                      _createVNode("div", _hoisted_12, [
                        _createVNode(_component_Input, {
                          type: "text",
                          name: "meta_title",
                          label: `${_ctx.$t('message.META')} ${_ctx.$t('message.TITLE')} (${_ctx.locale})`,
                          placeholder: 'message.ENTER message.META message.TITLE',
                          meta_title: _ctx.product.meta_title,
                          "onUpdate:meta_title": _cache[8] || (_cache[8] = ($event: any) => (_ctx.product.meta_title = $event)),
                          target: "meta_title",
                          onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.updateValue(_ctx.product.meta_title, 'metaTitle'))),
                          value: _ctx.product.meta_title
                        }, null, 8, ["label", "placeholder", "meta_title", "value"])
                      ]),
                      _createVNode("div", _hoisted_13, [
                        _createVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('message.META')) + " " + _toDisplayString(_ctx.$t('message.TAGS')) + " (" + _toDisplayString(_ctx.locale) + ") ", 1),
                        _createVNode(_component_Select, {
                          name: "meta_tags",
                          target: "meta_tags",
                          callEmit: true,
                          onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.updateValue(_ctx.product.meta_tags, 'metaTag'))),
                          multiple: true,
                          filterable: true,
                          allowCreateNew: true,
                          placeholder: `${_ctx.$t('message.META')} ${_ctx.$t('message.TAGS')}`,
                          meta_tags: _ctx.product.meta_tags,
                          "onUpdate:meta_tags": _cache[11] || (_cache[11] = ($event: any) => (_ctx.product.meta_tags = $event)),
                          value: _ctx.product.meta_tags,
                          selectData: _ctx.locale_meta_tags
                        }, null, 8, ["placeholder", "meta_tags", "value", "selectData"])
                      ]),
                      _createVNode("div", _hoisted_15, [
                        _createVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('message.META_DESCRIPTION')) + " (" + _toDisplayString(_ctx.locale) + ") ", 1),
                        _createVNode(_component_QuillEditor, {
                          onTextChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onEditorChange($event, 'metaDescription'))),
                          contentType: "html",
                          ref: "editorFormMeta",
                          theme: "snow",
                          content: _ctx.product.meta_description,
                          "onUpdate:content": _cache[13] || (_cache[13] = ($event: any) => (_ctx.product.meta_description = $event)),
                          toolbar: "essential"
                        }, null, 8, ["content"])
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_tab_pane, {
                  label: `${_ctx.$t('message.MEDIA')} (Optional)`
                }, {
                  default: _withId(() => [
                    _createVNode(_component_ProductToMedia, { onMedia: _ctx.getProductMedia }, null, 8, ["onMedia"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                (_ctx.renderAttribute == true)
                  ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                      key: 0,
                      label: `${_ctx.$t('message.ATTRIBUTES')}`
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_ProductToAttributes, {
                          locale: _ctx.locale,
                          onProductAttributeData: _ctx.getProductAttributes
                        }, null, 8, ["locale", "onProductAttributeData"])
                      ]),
                      _: 1
                    }, 8, ["label"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_tab_pane, {
                  label: `${_ctx.$t('message.PRICES')} & ${_ctx.$t('message.TAXES')}`
                }, {
                  default: _withId(() => [
                    _createVNode(_component_ProductToPrice, {
                      locale: _ctx.locale,
                      sites: _ctx.selectedSites.length ? _ctx.selectedSites : _ctx.sites,
                      onPriceData: _ctx.getPrice
                    }, null, 8, ["locale", "sites", "onPriceData"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_tab_pane, {
                  label: _ctx.$t('message.PRICE_GROUPS'),
                  name: "price_group"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_tabs, {
                      class: "price-groups-tabs",
                      "tab-position": 'top',
                      modelValue: _ctx.tabsValue,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.tabsValue = $event))
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_tab_pane, {
                          label: _ctx.$t('message.PRICE_GROUPS')
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_ProductToPriceGroups, {
                              onPriceGroupsData: _ctx.getPriceGroupLists,
                              ref: "priceGroupRef"
                            }, null, 8, ["onPriceGroupsData"])
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_el_tab_pane, {
                          label: _ctx.$t('message.CUSTOMER_PRICE')
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_ProductToCustomerPrices, {
                              onCustomerPricesData: _ctx.getCustomerPriceLists,
                              ref: "customerPriceRef"
                            }, null, 8, ["onCustomerPricesData"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_tab_pane, {
                  label: _ctx.$t('message.DIMENSIONS'),
                  name: "dimension"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_ProductToDimension, {
                      onDimensionData: _ctx.getDimensions,
                      ref: "dimensionRef"
                    }, null, 8, ["onDimensionData"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }, 8, ["modelValue", "onTabClick"])
          ]),
          _createVNode("div", _hoisted_17, [
            _createVNode(_component_el_divider, { direction: "vertical" })
          ]),
          _createVNode("div", _hoisted_18, [
            _createVNode("div", _hoisted_19, [
              _createVNode("button", {
                type: "reset",
                class: "btn btn-white me-3",
                "data-bs-dismiss": "modal",
                onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.goBack()))
              }, _toDisplayString(_ctx.$t('message.CANCEL')), 1),
              _createVNode("button", {
                type: "button",
                class: "btn btn-custom",
                onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.handlerSubmitForm()))
              }, [
                _createVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('message.SUBMIT')), 1)
              ])
            ]),
            _createVNode("div", _hoisted_21, [
              _createVNode("label", _hoisted_22, _toDisplayString(`${_ctx.$t('message.LANGUAGE')} ${_ctx.$t('message.SWITCH')}`), 1),
              _createVNode("div", _hoisted_23, [
                _createVNode(_component_Select, {
                  name: "locale",
                  target: "locale",
                  callEmit: true,
                  required: false,
                  label: false,
                  locale: _ctx.locale,
                  "onUpdate:locale": _cache[18] || (_cache[18] = ($event: any) => (_ctx.locale = $event)),
                  selectData: _ctx.locales,
                  value: _ctx.locale,
                  onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.changeLang(_ctx.locale)))
                }, null, 8, ["locale", "selectData", "value"])
              ])
            ]),
            _createVNode("div", _hoisted_24, [
              _createVNode("label", _hoisted_25, _toDisplayString(_ctx.$t('message.COMBINATION')), 1),
              _createVNode("div", null, [
                _createVNode(_component_Radio, {
                  name: "radio2",
                  size: "medium",
                  target: "radio2",
                  value: _ctx.radio2,
                  radio2: _ctx.radio2,
                  "onUpdate:radio2": _cache[20] || (_cache[20] = ($event: any) => (_ctx.radio2 = $event)),
                  display: _ctx.block,
                  options: _ctx.combinations,
                  onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.changeCombination(_ctx.radio2)))
                }, null, 8, ["value", "radio2", "display", "options"])
              ])
            ]),
            _createVNode("div", _hoisted_26, [
              _createVNode("label", _hoisted_27, _toDisplayString(_ctx.$t('message.PRODUCT_FAMILY')), 1),
              _createVNode(_component_Select, {
                name: "family",
                target: "family",
                required: false,
                clearable: true,
                label: false,
                multiple: false,
                filterable: true,
                placeholder: 'message.SELECT',
                family: _ctx.product.family,
                "onUpdate:family": _cache[22] || (_cache[22] = ($event: any) => (_ctx.product.family = $event)),
                selectData: _ctx.families,
                value: _ctx.product.family
              }, null, 8, ["placeholder", "family", "selectData", "value"])
            ]),
            _createVNode("div", _hoisted_28, [
              _createVNode("label", _hoisted_29, _toDisplayString(_ctx.$t('message.CATEGORIES')), 1),
              _createVNode(_component_Select, {
                name: "categories",
                target: "categories",
                required: true,
                label: false,
                multiple: true,
                filterable: true,
                placeholder: 'message.SELECT',
                categories: _ctx.product.categories,
                "onUpdate:categories": _cache[23] || (_cache[23] = ($event: any) => (_ctx.product.categories = $event)),
                selectData: _ctx.categories,
                value: _ctx.product.categories
              }, null, 8, ["placeholder", "categories", "selectData", "value"])
            ]),
            _createVNode("div", _hoisted_30, [
              _createVNode("label", _hoisted_31, _toDisplayString(`${_ctx.$t('message.LIMIT_CART')} ${_ctx.$t('message.PRODUCT')}`), 1),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sites, (site, index) => {
                return (_openBlock(), _createBlock("div", { key: index }, [
                  _createVNode(_component_Checkbox, {
                    name: "site",
                    size: 'medium',
                    target: "site",
                    displayMessage: site.label,
                    site: _ctx.limitCart[site.value],
                    "onUpdate:site": ($event: any) => (_ctx.limitCart[site.value] = $event)
                  }, null, 8, ["displayMessage", "site", "onUpdate:site"]),
                  (_ctx.limitCart[site.value] == true)
                    ? (_openBlock(), _createBlock("div", _hoisted_32, [
                        _createVNode("div", _hoisted_33, [
                          _createVNode("div", _hoisted_34, [
                            _createVNode(_component_Input, {
                              type: "number",
                              name: "multi",
                              label: false,
                              placeholder: _ctx.$t('message.MAXIMUM_LIMIT_FOR_MULTIPLES'),
                              multi: _ctx.product.multiple[site.value],
                              "onUpdate:multi": ($event: any) => (_ctx.product.multiple[site.value] = $event),
                              target: "multi",
                              value: _ctx.product.multiple[site.value]
                            }, null, 8, ["placeholder", "multi", "onUpdate:multi", "value"])
                          ]),
                          _createVNode("div", _hoisted_35, [
                            _createVNode(_component_Input, {
                              type: "number",
                              name: "lim",
                              label: false,
                              placeholder: _ctx.$t('message.MULTIPLE_NUMBER_FOR_MINIMUM_ORDER'),
                              lim: _ctx.product.limit[site.value],
                              "onUpdate:lim": ($event: any) => (_ctx.product.limit[site.value] = $event),
                              target: "lim",
                              value: _ctx.product.limit[site.value]
                            }, null, 8, ["placeholder", "lim", "onUpdate:lim", "value"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _createVNode("div", _hoisted_36, [
              _createVNode("label", _hoisted_37, _toDisplayString(_ctx.$t('message.QUANTITY')), 1),
              _createVNode("div", _hoisted_38, [
                _createVNode(_component_el_input_number, {
                  modelValue: _ctx.product.quantity,
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.product.quantity = $event)),
                  min: 0
                }, null, 8, ["modelValue"]),
                (_ctx.product.quantity == null && _ctx.validate == true)
                  ? (_openBlock(), _createBlock("div", _hoisted_39, _toDisplayString(`${_ctx.$t('message.THIS_FIELD')} ${_ctx.$t('message.IS_REQUIRED')}`), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_40, [
              _createVNode("div", _hoisted_41, [
                _createVNode("label", _hoisted_42, _toDisplayString(_ctx.$t('message.MANUFACTURERS')), 1),
                _createVNode(_component_Select, {
                  name: "manufacturer",
                  target: "manufacturer",
                  label: false,
                  placeholder: 'message.PRODUCT',
                  manufacturer: _ctx.product.manufacturer,
                  "onUpdate:manufacturer": _cache[25] || (_cache[25] = ($event: any) => (_ctx.product.manufacturer = $event)),
                  selectData: _ctx.manufacturers,
                  value: _ctx.product.manufacturer
                }, null, 8, ["placeholder", "manufacturer", "selectData", "value"])
              ]),
              _createVNode("div", _hoisted_43, [
                _createVNode("label", _hoisted_44, _toDisplayString(_ctx.$t('message.SEND_INQUIRY')), 1),
                _createVNode(_component_Select, {
                  name: "inquiry",
                  target: "inquiry",
                  label: false,
                  placeholder: 'message.SELECT',
                  inquiry: _ctx.product.inquiry,
                  "onUpdate:inquiry": _cache[26] || (_cache[26] = ($event: any) => (_ctx.product.inquiry = $event)),
                  selectData: _ctx.inquires,
                  value: _ctx.product.inquiry
                }, null, 8, ["placeholder", "inquiry", "selectData", "value"])
              ])
            ]),
            _createVNode("div", _hoisted_45, [
              _createVNode("div", _hoisted_46, [
                _createVNode(_component_Select, {
                  name: "related_products",
                  target: "related_products",
                  label: `${_ctx.$t('message.RELATED_PRODUCTS')}`,
                  multiple: true,
                  filterable: true,
                  placeholder: 'message.PRODUCTS',
                  related_products: _ctx.product.related_products,
                  "onUpdate:related_products": _cache[27] || (_cache[27] = ($event: any) => (_ctx.product.related_products = $event)),
                  selectData: _ctx.products,
                  value: _ctx.product.related_products
                }, null, 8, ["label", "placeholder", "related_products", "selectData", "value"])
              ])
            ])
          ])
        ]),
        _hoisted_47
      ]),
      _: 1
    }, 8, ["model"])
  ]))
})